// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"02a97632","138":"22141c13","164":"7615ffdb","245":"b1feb539","246":"a4508a4f","255":"ad290470","279":"ee27e0af","311":"eb274b19","452":"d0c3fa2a","469":"1a48a461","531":"6f6f8228","545":"e5e92247","592":"9518263f","791":"edb0ea2c","844":"f108af19"}[chunkId] + ".chunk.js";
};